import { LeavingGuard } from '@components/utils/LeavingGuard';
import { Banner, Button, ButtonClean, Checkbox, Fieldset, Icon, InputUI, Subsection, } from '@fourthwall/components';
import { SpotifyIcon } from '@fourthwall/icons';
import { TagSelect } from '@modules/Dashboard/Memberships/components/TagSelect';
import { ConfirmBar } from '@modules/Dashboard/modules/ConfirmBar';
import React from 'react';
import { usePodcastContext } from '../../hooks/usePodcastContext';
import { CopyInput } from '../CopyInput/CopyInput';
import { SyncedBar } from '../SyncedBar/SyncedBar';
import { SyncingBar } from '../SyncingBar/SyncingBar';
import { Video } from '../Video/Video';
import * as S from './ExistingFields.styled';
export const ExistingFields = () => {
    const { podcast, tags, selectedTags, form, isLoading, handleAddTag, handleRemoveTag, handleSyncPodcast, handleDesyncPodcast, } = usePodcastContext();
    if (!podcast)
        return null;
    return (React.createElement(Subsection, { title: "Add members-only audio to this podcast" },
        React.createElement(Video, null),
        React.createElement("div", { style: { marginBottom: 16 } }, "Follow the steps below to allow your members to listen to members-only audio on Spotify:"),
        React.createElement(S.List, null,
            React.createElement("li", null,
                React.createElement(S.ListItem, null,
                    "Sync your members-only audio to Spotify.",
                    podcast.status === 'Created' && (React.createElement(Button, { appearance: "secondary", leftIcon: React.createElement(Icon, { component: SpotifyIcon, height: 20 }), iconColor: "#1ed760", label: "Sync podcast to Spotify", loading: isLoading, onClick: handleSyncPodcast })),
                    podcast.status === 'Syncing' && React.createElement(SyncingBar, { loading: isLoading }),
                    podcast.status === 'Synced' && (React.createElement(SyncedBar, { url: podcast.spotifyUrl || '', loading: isLoading, onClick: handleDesyncPodcast })),
                    podcast.status === 'Errored' && (React.createElement(SyncedBar, { url: podcast.spotifyUrl || '', errored: true, loading: isLoading, onClick: handleDesyncPodcast })),
                    React.createElement("div", { style: { width: '100%' } },
                        React.createElement(Fieldset, null,
                            podcast.status === 'Errored' && podcast.ingestionValidationErrors && (React.createElement(Fieldset.Row, null,
                                React.createElement(Banner, { appearance: "danger", title: podcast.ingestionValidationErrors }))),
                            React.createElement(Fieldset.Row, null,
                                React.createElement(Checkbox, { label: "Sync only audio posts with specific tags to Spotify", ...form.getFieldProps('withTags') })),
                            form.values.withTags && (React.createElement(Fieldset.Row, { inner: true },
                                React.createElement(S.TagSelectContainer, null,
                                    React.createElement(TagSelect, { label: tags.length === 0 ? 'You haven’t created any tags yet' : 'Select tags', selectedTags: selectedTags, tags: tags, onAdd: handleAddTag, onRemove: handleRemoveTag }),
                                    form.errors.tags && (React.createElement(InputUI.Error, null, form.errors.tags.toString()))))))))),
            React.createElement("li", null,
                "Go to",
                ' ',
                React.createElement(ButtonClean, { label: "Spotify for Creators", withUnderline: true, href: "https://creators.spotify.com/", target: "_blank" }),
                ' ',
                "and login to the Spotify account your main podcast is under."),
            React.createElement("li", null,
                "Click the small circle account icon in the top right of the page and select",
                ' ',
                React.createElement(S.Bold, null, "Add a new show"),
                "."),
            React.createElement("li", null,
                "Select ",
                React.createElement(S.Bold, null, "Find an existing show"),
                ", then choose that podcast is hosted",
                ' ',
                React.createElement(S.Bold, null, "Somewhere else"),
                "."),
            React.createElement("li", null,
                React.createElement(S.ListItem, null,
                    "Copy the link below and paste it into \u201CRSS feed link\u201D field.",
                    React.createElement(CopyInput, { url: podcast.rssUrl || '' }))),
            React.createElement("li", null, "You should now see your members-only audio on your Spotify account."),
            React.createElement("li", null,
                "Select your main podcast from the ",
                React.createElement(S.Bold, null, "Your shows"),
                " menu on the left."),
            React.createElement("li", null,
                "Click ",
                React.createElement(S.Bold, null, "Settings"),
                " on the left menu."),
            React.createElement("li", null,
                "Scroll down to the ",
                React.createElement(S.Bold, null, "Synced feeds"),
                " section and click",
                ' ',
                React.createElement(S.Bold, null, "Learn more"),
                " and then ",
                React.createElement(S.Bold, null, "Get started"),
                "."),
            React.createElement("li", null,
                "On the ",
                React.createElement(S.Bold, null, "Link your feeds"),
                " page, select your podcast in the",
                ' ',
                React.createElement(S.Bold, null, "Paid feed"),
                " dropdown and click ",
                React.createElement(S.Bold, null, "Next"),
                "."),
            React.createElement("li", null, "Select your perks to complete the process! Your members-only audio should now show up under your podcast.")),
        React.createElement(ConfirmBar, { isOpen: form.dirty, isLoading: isLoading, onConfirm: form.submitForm, onCancel: form.resetForm }),
        React.createElement(LeavingGuard, { when: form.dirty, isValid: form.isValid, onSave: form.submitForm })));
};
